"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPrivacyNoticeWrapper = void 0;
const lib_1 = require("@brandfree-front/lib");
const helper_1 = require("@telia-front/helper");
const react_1 = __importDefault(require("react"));
const PublicPrivacyNotice_1 = __importDefault(require("./PublicPrivacyNotice"));
const PublicPrivacyNoticeWrapper = () => {
    const { breakPoints } = (0, lib_1.useTheme)();
    const currentBreakPoint = (0, helper_1.useCurrentBreakPoint)(breakPoints);
    const isMobile = currentBreakPoint === 'xs' || currentBreakPoint === 'sm';
    return react_1.default.createElement(PublicPrivacyNotice_1.default, { isMobile: isMobile });
};
exports.PublicPrivacyNoticeWrapper = PublicPrivacyNoticeWrapper;
